export interface Testimonial {
  id: string;
  name: string;
  origin: string;
  rating: number;
  textEs: string;
  textEn: string;
  source: 'tripadvisor' | 'booking' | 'google';
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'María González',
    origin: 'Tegucigalpa, Honduras',
    rating: 5,
    textEs: 'Un hotel hermoso con un servicio excepcional. La ubicación es perfecta, a pasos de la Catedral. El desayuno es delicioso y el personal muy amable.',
    textEn: 'A beautiful hotel with exceptional service. The location is perfect, steps from the Cathedral. The breakfast is delicious and the staff very friendly.',
    source: 'tripadvisor',
    date: '2025-12',
  },
  {
    id: '2',
    name: 'John Smith',
    origin: 'Texas, USA',
    rating: 5,
    textEs: 'La mejor experiencia en Honduras. Las habitaciones son encantadoras y el desayuno incluido es perfecto para comenzar el día explorando Comayagua.',
    textEn: 'The best experience in Honduras. The rooms are charming and the included breakfast is perfect for starting the day exploring Comayagua.',
    source: 'booking',
    date: '2025-11',
  },
  {
    id: '3',
    name: 'Carlos Mejía',
    origin: 'San Pedro Sula, Honduras',
    rating: 5,
    textEs: 'Siempre me hospedo aquí cuando visito Comayagua. El desayuno incluido es excelente y el servicio del equipo es inigualable.',
    textEn: 'I always stay here when visiting Comayagua. The included breakfast is excellent and the team service is unmatched.',
    source: 'tripadvisor',
    date: '2025-10',
  },
  {
    id: '4',
    name: 'Sophie Laurent',
    origin: 'Paris, France',
    rating: 4,
    textEs: 'Un verdadero tesoro escondido. El hotel combina perfectamente las instalaciones modernas con la calidez hondureña. La ubicación en el centro de Comayagua es ideal.',
    textEn: 'A true hidden gem. The hotel perfectly blends modern facilities with Honduran warmth. The central Comayagua location is ideal.',
    source: 'google',
    date: '2025-09',
  },
];
